import { OGProperties, PageTags } from '../types';
import { RoutesPaths } from '@router/constants';

const title = 'KYC Process'
const url = window.location.origin + RoutesPaths.KYC_PROCESS

export const kycPage: PageTags = {
  title: `| ${title}`,
  url: url,
  properties: [
    {
      property: OGProperties.title,
      content: `FireStarter | ${title}`,
    },
    {
      property: OGProperties.description,
      content: 'Complete KYC process to participate in early funding rounds.',
    },
    {
      property: OGProperties.url,
      content: url,
    },
  ]
}
